module.exports = __webpack_public_path__ + "static/media/ZSCE_MF_CIDADES_TROCA.0a9445db.pdf";